import React from 'react';
import { useChatContext } from '../context/ChatContext';
import LandingView from './LandingView';
import ChatView from './ChatView';
import ChatHistoryView from './ChatHistoryView';

  // console.log('MainContent rendered');

const MainContent: React.FC = () => {
  const { uiState } = useChatContext();

  return (
    <div
      className={`main-content ${uiState.rightSidebarCollapsed ? 'right-collapsed' : ''}`}
      style={{
        position: 'absolute',
        left: uiState.sidebarCollapsed ? '60px' : '300px',
        right: uiState.rightSidebarCollapsed ? '60px' : '800px',
        width: 'auto',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        transition: 'left 0.3s cubic-bezier(0.4, 0, 0.2, 1), right 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
      }}
    >
      <div className="centered-content">
        {uiState.showAllChatsView ? (
          <ChatHistoryView />
        ) : uiState.isLandingView ? (
          <LandingView />
        ) : <ChatView />}
      </div>
    </div>
  );
};

export default MainContent; 